import './App.css';
import Chess from './Chess';

function App() {
  return (
    <Chess />
  );
}

export default App;
